import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';

const messages = defineMessages({
  title: {
    description: 'batchesListPlaceholder.title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'DOg7Ip',
  },
  description: {
    description: 'batchesListPlaceholder.description',
    defaultMessage: 'There are currently no records',
    id: 'drty4h',
  },
  boldStatusView: {
    description: 'batchesListPlaceholder.boldStatusView',
    defaultMessage: 'Batches',
    id: 'bKB6iA',
  },
});

const BatchesPlaceholder = () => (
  <ActionablePlaceholder
    description={<FormattedMessage {...messages.description} />}
    title={
      <FormattedMessage
        {...messages.title}
        values={{
          statusView: (
            <b>
              <FormattedMessage {...messages.boldStatusView} />
            </b>
          ),
        }}
      />
    }
  />
);

export default BatchesPlaceholder;
